import React from 'react';

import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

import { UPDATE_TYPES, UpdateType } from 'services/caxyLightstream';

const EntryWrapper = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-column-gap: 0.75rem;
  grid-row-gap: 0;
  border-right: 1px solid ${({ theme }) => theme.colors.borderLightGray2};
  grid-template-rows: auto;
  grid-template-columns: auto auto auto auto;
  margin-right: 0.75rem;
  margin-top: 0.5rem;
  padding-right: 0.75rem;
`;

const Cell = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: row;
  align-items: center;
  text-wrap: nowrap;
`;

const Currency = styled.div`
  font-size: 1rem;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.default};
`;

const Label = styled.div`
  font-size: 0.66rem;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.default};
  color: ${({ theme }) => theme.colors.gray};
  transform: rotate(-90deg);
`;

const Price = styled.div<{ $isDown: boolean; $isSnapshot: boolean }>`
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ $isDown, theme, $isSnapshot }) =>
    $isSnapshot ? theme.colors.gray : $isDown ? theme.colors.ttRed : theme.colors.upBlue};
  display: flex;
  padding: 0.25rem 0.75rem;
  gap: 0.33rem;
  align-items: center;
  justify-content: flex-start;
`;

const Change = styled.div<{ $isDown: boolean }>`
  color: ${({ $isDown, theme }) => ($isDown ? theme.colors.ttRed : theme.colors.upBlue)};
  font-size: 1rem;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.default};
`;

interface TickerEntryProps {
  currency: string;
  sell: string | number | undefined;
  sellUp: boolean;
  buy: string | number | undefined;
  buyUp: boolean;
  change: string | number | undefined;
  type: UpdateType | undefined;
}

const TickerEntry: React.FC<TickerEntryProps> = ({ currency, sell, sellUp, buy, buyUp, change, type }) => {
  return (
    <EntryWrapper>
      <Cell>
        <Currency>{currency}</Currency>
      </Cell>
      <Cell>
        <Label>SELL</Label>
        <Price $isDown={!sellUp} $isSnapshot={type === UPDATE_TYPES.SNAPSHOT}>
          {sell ?? '-'}
          {type === UPDATE_TYPES.UPDATE && <FontAwesomeIcon icon={sellUp ? faArrowUp : faArrowDown} />}
        </Price>
      </Cell>
      <Cell>
        <Label>BUY</Label>
        <Price $isDown={!buyUp} $isSnapshot={type === UPDATE_TYPES.SNAPSHOT}>
          {buy ?? '-'}
          {type === UPDATE_TYPES.UPDATE && <FontAwesomeIcon icon={buyUp ? faArrowUp : faArrowDown} />}
        </Price>
      </Cell>
      <Cell>
        <Label>CHG</Label>
        <Change $isDown={Number(change) < 0}>{change ?? '-'}</Change>
      </Cell>
    </EntryWrapper>
  );
};

export default TickerEntry;
